import { EntityServiceMock } from "./entity.types";

export const mockEntityService = (): EntityServiceMock => ({
  fetchEntities: jest.fn(),
  fetchEntitiesV2: jest.fn(),
  updateEntity: jest.fn(),
  changeStatus: jest.fn(),
  createEntity: jest.fn(),
});
